__webpack_require__.p = "https://checkout.y.uno/";